import React from 'react'
import { renderRoutes, matchRoutes } from 'react-router-config'
import { Empty } from 'antd'
import { useCheckAuth } from '@/hooks'
import { useTranslation } from 'react-i18next'

const PageEmpty = React.memo(() => {
  const { t } = useTranslation()

  return (
    <div
      style={{
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Empty description={t('common.noauth')} />
    </div>
  )
})

// 路由守卫组件 用于primaryLayout 的content中加一层拦截
function RouterGuard(props) {
  const { route, children } = props
  const { checkAuth } = useCheckAuth()
  const matchedRoutes = matchRoutes([route], location.pathname)
  const currentRoute = matchedRoutes[matchedRoutes.length - 1]
  const authed = checkAuth(currentRoute?.route?.authCode)
  const mainContent = children ? React.cloneElement(children, { children: renderRoutes(route.routes, props) }) : renderRoutes(route.routes, props)
  return <>{authed ? mainContent : <PageEmpty />}</>
}
export default React.memo(RouterGuard)
